import React from 'react';
import './CaseStudyLayouts.css';
import Navigation from './Navigation';

const CaseStudyLayouts = () => {
  const sampleContent = {
    title: "Sample Case Study",
    summary: "Brief overview of the project, its goals, and impact. This section provides a high-level understanding of what was accomplished.",
    challenge: "Description of the problem that needed to be solved. What obstacles and constraints were faced during this project?",
    role: "My specific role and the approach taken to tackle the challenge. What methodologies and processes were used?",
    findings: "Key insights and discoveries made during the research and development process. What did we learn?",
    deliverables: "Tangible outputs and solutions delivered. What concrete results were produced?",
    lessons: "Reflections on what worked well, what could be improved, and key takeaways for future projects."
  };

  return (
    <div className="case-study-layouts-page">
      <Navigation />
      
      <div className="layouts-header">
        <h1>Case Study Layout Options</h1>
        <p>Wireframe layouts for case study pages</p>
      </div>

      {/* Layout Option 1: Traditional Vertical */}
      <section className="layout-option" id="option-1">
        <h2 className="layout-title">Option 1: Traditional Vertical Flow</h2>
        <div className="layout-container traditional-vertical">
          <div className="hero-section wireframe">
            <div className="hero-content">
              <h1>{sampleContent.title}</h1>
              <div className="hero-meta">
                <span>Timeline</span>
                <span>Team Size</span>
                <span>Role</span>
              </div>
            </div>
            <div className="hero-image">Hero Image</div>
          </div>
          
          <div className="content-section">
            <div className="section-block">
              <h3>Summary</h3>
              <p>{sampleContent.summary}</p>
            </div>
            
            <div className="section-block">
              <h3>The Challenge</h3>
              <p>{sampleContent.challenge}</p>
            </div>
            
            <div className="section-block">
              <h3>My Role & Approach</h3>
              <p>{sampleContent.role}</p>
            </div>
            
            <div className="section-block">
              <h3>Findings</h3>
              <p>{sampleContent.findings}</p>
            </div>
            
            <div className="section-block">
              <h3>Key Deliverables</h3>
              <p>{sampleContent.deliverables}</p>
            </div>
            
            <div className="section-block">
              <h3>Lessons Learned</h3>
              <p>{sampleContent.lessons}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Layout Option 2: Two-Column Split */}
      <section className="layout-option" id="option-2">
        <h2 className="layout-title">Option 2: Two-Column Layout</h2>
        <div className="layout-container two-column">
          <div className="hero-section wireframe">
            <div className="hero-content">
              <h1>{sampleContent.title}</h1>
              <div className="hero-meta">
                <span>Timeline</span>
                <span>Team Size</span>
                <span>Role</span>
              </div>
            </div>
            <div className="hero-image">Hero Image</div>
          </div>
          
          <div className="two-column-content">
            <div className="left-column">
              <div className="section-block">
                <h3>Summary</h3>
                <p>{sampleContent.summary}</p>
              </div>
              
              <div className="section-block">
                <h3>My Role & Approach</h3>
                <p>{sampleContent.role}</p>
              </div>
              
              <div className="section-block">
                <h3>Key Deliverables</h3>
                <p>{sampleContent.deliverables}</p>
              </div>
            </div>
            
            <div className="right-column">
              <div className="section-block">
                <h3>The Challenge</h3>
                <p>{sampleContent.challenge}</p>
              </div>
              
              <div className="section-block">
                <h3>Findings</h3>
                <p>{sampleContent.findings}</p>
              </div>
              
              <div className="section-block">
                <h3>Lessons Learned</h3>
                <p>{sampleContent.lessons}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Layout Option 3: Card-Based Grid */}
      <section className="layout-option" id="option-3">
        <h2 className="layout-title">Option 3: Card-Based Grid</h2>
        <div className="layout-container card-grid">
          <div className="hero-section wireframe">
            <div className="hero-content">
              <h1>{sampleContent.title}</h1>
              <div className="hero-meta">
                <span>Timeline</span>
                <span>Team Size</span>
                <span>Role</span>
              </div>
            </div>
            <div className="hero-image">Hero Image</div>
          </div>
          
          <div className="cards-grid">
            <div className="card-item summary-card">
              <h3>Summary</h3>
              <p>{sampleContent.summary}</p>
            </div>
            
            <div className="card-item challenge-card">
              <h3>The Challenge</h3>
              <p>{sampleContent.challenge}</p>
            </div>
            
            <div className="card-item role-card">
              <h3>My Role & Approach</h3>
              <p>{sampleContent.role}</p>
            </div>
            
            <div className="card-item findings-card">
              <h3>Findings</h3>
              <p>{sampleContent.findings}</p>
            </div>
            
            <div className="card-item deliverables-card">
              <h3>Key Deliverables</h3>
              <p>{sampleContent.deliverables}</p>
            </div>
            
            <div className="card-item lessons-card">
              <h3>Lessons Learned</h3>
              <p>{sampleContent.lessons}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Layout Option 4: Progressive Disclosure */}
      <section className="layout-option" id="option-4">
        <h2 className="layout-title">Option 4: Progressive Disclosure / Timeline</h2>
        <div className="layout-container timeline">
          <div className="hero-section wireframe">
            <div className="hero-content">
              <h1>{sampleContent.title}</h1>
              <div className="hero-meta">
                <span>Timeline</span>
                <span>Team Size</span>
                <span>Role</span>
              </div>
            </div>
            <div className="hero-image">Hero Image</div>
          </div>
          
          <div className="timeline-content">
            <div className="timeline-item">
              <div className="timeline-marker">1</div>
              <div className="timeline-content-block">
                <h3>Summary</h3>
                <p>{sampleContent.summary}</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-marker">2</div>
              <div className="timeline-content-block">
                <h3>The Challenge</h3>
                <p>{sampleContent.challenge}</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-marker">3</div>
              <div className="timeline-content-block">
                <h3>My Role & Approach</h3>
                <p>{sampleContent.role}</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-marker">4</div>
              <div className="timeline-content-block">
                <h3>Findings</h3>
                <p>{sampleContent.findings}</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-marker">5</div>
              <div className="timeline-content-block">
                <h3>Key Deliverables</h3>
                <p>{sampleContent.deliverables}</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-marker">6</div>
              <div className="timeline-content-block">
                <h3>Lessons Learned</h3>
                <p>{sampleContent.lessons}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CaseStudyLayouts;